// extracted by mini-css-extract-plugin
export default {"wrap":"inline-form_wrap__CCA+-"};